import { useDataTable } from "@/lib/hooks/use-data-table.ts";
import { DataTable } from "@/components/data-table/data-table.tsx";
import { getColumns } from "@/components/users/user-details/mentorships/columns.tsx";
import { Mentorship } from "@/lib/api/mentorships.ts";
import { useRouter } from "@tanstack/react-router";

interface MentorshipsProps {
  userId: string;
  isMentor: boolean;

  mentorships: Mentorship[];
  isPending: boolean;
}

export const Mentorships = ({
  userId,
  isMentor,
  isPending,
  mentorships,
}: MentorshipsProps) => {
  const router = useRouter();
  const { table } = useDataTable({
    columns: getColumns(userId, isMentor, mentorships),
    data: mentorships || [],
    defaultPerPage: 10,
    pageCount: -1,
    filterFields: [],
    disablePagination: true,
  });

  return (
    <div>
      <DataTable
        table={table}
        isPending={isPending}
        disablePagination
        onRowClick={(row, options) => {
          const url = `/mentorships/${row.mentorship_id}`;
          if (options?.getNavigationUrl) {
            return url;
          }
          router.navigate({ to: url });
        }}
      />
    </div>
  );
};
